import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { default as ModalUI } from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material";

const Modal = ({ title, children, open, setOpen, displayAcceptAction, displayCancelAction, onCloseCallback }: any) => {
  const handleClose = () => {
    setOpen(false);
    onCloseCallback && onCloseCallback();
  };

  return (
    <ModalUI
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <ModalWrapper>
          <CloseButton onClick={handleClose}>
            <MotalTitle>
              <Typography id='transition-modal-title' variant='h6' component='h2' align='center'>
                {title}
              </Typography>
            </MotalTitle>
            <IconButton aria-label='delete' size='small'>
              <CloseIcon fontSize='inherit' />
            </IconButton>
          </CloseButton>
          <ModalContent>{children}</ModalContent>
          <ModalActions>
            {displayAcceptAction && <Button variant='contained'>Aceptar</Button>}
            {displayCancelAction && (
              <Button variant='outlined' onClick={handleClose}>
                Cerrar
              </Button>
            )}
          </ModalActions>
        </ModalWrapper>
      </Fade>
    </ModalUI>
  );
};

export default Modal;

const ModalWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 24;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: ${({ theme }) => theme.spacing(0, 2)};
  transform: translate(-50%, -50%);
  width: 400px;
`;

const CloseButton = styled("div")`
  display: flex;
  height: 2.5rem;
  justify-content: space-around;
  align-items: center;
`;

const MotalTitle = styled("div")`
  flex: 1;
  color: ${({ theme }) => theme.palette.text.primary};
  width: 100%;
`;

const ModalContent = styled("div")`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(2, 0)};
  width: 100%;
`;
const ModalActions = styled("div")`
  display: flex;
  justify-content: space-around;
  padding: ${({ theme }) => theme.spacing(1)};
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;
